import dayjs from 'dayjs'
import { z } from 'zod'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

export const goalFormSchema = z
  .object({
    amount: z
      .number({
        invalid_type_error: FORM_MESSAGES_MAP.EMPTY,
        required_error: FORM_MESSAGES_MAP.REQUIRED,
      })
      .min(0),
    dueDate: z
      .string({ required_error: FORM_MESSAGES_MAP.REQUIRED })
      .min(1, { message: FORM_MESSAGES_MAP.EMPTY }),
    monthlyReminder: z.boolean(),
    monthlyReminderAmount: z.number().min(0).optional(),
    name: z
      .string({ required_error: FORM_MESSAGES_MAP.REQUIRED })
      .min(1, { message: FORM_MESSAGES_MAP.EMPTY }),
    startDate: z
      .string({ required_error: FORM_MESSAGES_MAP.REQUIRED })
      .min(1, { message: FORM_MESSAGES_MAP.EMPTY }),
  })
  .superRefine((data, ctx) => {
    if (data.monthlyReminder && !data.monthlyReminderAmount) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: FORM_MESSAGES_MAP.EMPTY,
      })
    }

    if (dayjs(data.startDate).isAfter(dayjs(data.dueDate))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: FORM_MESSAGES_MAP.DATE_BEFORE,
      })
    }

    return true
  })
